import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

export default function SelectComoConheceu(props) {
  return (
    <>
      <InputLabel shrink id="label-select-howDidYouGetUs">
        Como você nos conheceu?
      </InputLabel>
      <Select
        labelId="label-select-howDidYouGetUs"
        id="howDidYouGetUs"
        name="howDidYouGetUs"
        label="Como você nos conheceu?"
        fullWidth
        variant="outlined"
        placeholder="Selecione..."
        {...props}>
        <MenuItem value={2013}>Google</MenuItem>
        <MenuItem value={2057}>Instagram</MenuItem>
        <MenuItem value={2017}>Facebook</MenuItem>
        <MenuItem value={2063}>Influencer</MenuItem>
        <MenuItem value={2014}>Indicação</MenuItem>
        <MenuItem value={2060}>E-mail</MenuItem>
        <MenuItem value={2020}>Outros</MenuItem>
      </Select>
    </>
  );
}
